
import {Constant} from "../common/constant";
export const ROUTE_INVESTOR: any = [
  {path: Constant.url_investor_profile},
  {path: Constant.url_investor_profile + '/:tab'},
];

export const ROUTE_ISSUER: any = [
      { path: Constant.url_issuer_products},
      { path: Constant.url_issuer_products + '/:tab'},
      { path: Constant.url_issuer_profile },
      { path: Constant.url_issuer_change_pass},
      { path: Constant.url_issuer_transaction},
      { path: Constant.url_issuer_create_bonds},
      { path: Constant.url_issuer_create_bonds+'/:id'},
      { path: Constant.url_issuer_create_new_fund},
      { path: Constant.url_issuer_create_new_fund+'/:id'},
      { path: Constant.url_issuer_create_certificate_deposit},
      { path: Constant.url_issuer_create_certificate_deposit+'/:id'},
      { path: Constant.url_issuer_money},
      { path: Constant.url_issuer_report},
      { path: Constant.url_issuer_agency},
      { path: Constant.url_issuer_help},
];
export const ROUTE_AGENT: any = [
      { path: Constant.url_agent_transaction},
      { path: Constant.url_agent_profile},
      { path: Constant.url_agent_change_pass },
      { path: Constant.url_agent_user_doc},
      { path: Constant.url_agent_user_doc + '/:tab' },
      { path: Constant.url_agent_change_profile},
      { path: Constant.url_agent_change_profile + '/:tab' },
];